const rewardsRoutes = {
  rewards: 'app',
  containers: {
    authentication: 'authentication',
    home: 'home',
    rewardhero: 'rewards-hero-tab',
    account: 'account',
    locations: 'locations',
    getApp: 'get-app',
    rewardList: 'list',
    dealDetail: 'detail',
    couponDetail: 'coupon',
    rewardProgramDetails: 'program-details',
    referral: 'referral',
    coupons: 'coupons',
    deleteAccountSuccess: 'delete-account-success',
    aboutUs: 'about-us',
    communityOrdering: 'community-ordering',
    workWithUs: 'work-with-us',
    franchiseEnquiry: 'franchise-enquiry',
    ordering: 'ordering',
    deals: 'deals',
    helpSupport: 'help-support',
    scan: 'scan',
    vipPassList: 'pass-list',
    vipPassDetail: 'pass-detail',
    vipMembershipList: 'membership-list',
    payment: 'payment',
    myRewards: 'my-rewards',
    payEarn: 'pay-earn',
    bookTable: 'book-table',
    tableBookings: 'table-bookings',
    delivery: 'delivery-address',
    selectOutlet: 'select-outlet',
    location: 'location',
    view: 'view',
    permissionsAndPrivacy: 'permissions-and-privacy',
    wallet: 'wallet',
  },
  authentication: {
    signUp: 'signup',
    signIn: 'signin',
  },
  payEarn: {
    selectBrand: 'select-brand',
    selectOutlet: 'select-outlet',
    enterAmount: 'enter-amount',
    payAmount: 'pay-amount',
    coupons: 'coupons',
    couponDetails: 'couponDetails',
    payment: 'payment',
    confirmation: 'confirmation',
  },
  bookTable: {
    selectBrand: 'select-brand',
    selectOutlet: 'select-outlet',
    selectTable: 'select-table',
    confirmation: 'confirmation',
  },
  view: {
    instagram: 'ig',
    whatsapp: 'wb',
  },
  wallet: {
    home: 'home',
    recharge: 'recharge',
    payment: 'payment',
    details: 'details',
    transactionDetails: 'transaction-details',
  },
};

export default rewardsRoutes;
